import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import {reject} from "q";
import {ancestorWhere} from "tslint";

@Injectable()
export class DatabaseService {

  constructor(public store: AngularFirestore) { }

  setUser(user: object, data) {
    return this.store.collection('users').doc(data['uid']).set({
      nom: user['lastname'],
      prenom: user['firstname'],
      email: user['email'],
      entreprise: user['company'],
      poste: user['poste'],
      tel: user['tel'],
      siret: user['siret'],
      uid: data['uid']
    });
  }

  addUser(uid, data) {
    this.store.collection('users').doc(uid).update(data);
  }

  addfield(uid, data) {
    this.store.collection('users').doc(uid).collection('devis').add(data).then(info => {
      this.store.collection('users').doc(uid).collection('devis').doc(info.id).update({
        id: info.id
      });
    });
  }

  addComment(uid, data) {
    this.store.collection('users').doc(uid).collection('commandes').add(data).then(info => {
      this.store.collection('users').doc(uid).collection('commandes').doc(info.id).update({
        id: info.id
      });
    });
  }

  getmydevis(uid) {
    return this.store.collection('users').doc(uid).collection('devis');
  }

  getmycomment(uid) {
    return this.store.collection('users').doc(uid).collection('commandes');
  }

  deleteDevis(uid, index) {
    return this.store.collection('users').doc(uid).collection('devis').doc(index).delete();
  }

  deleteComment(uid, index) {
    return this.store.collection('users').doc(uid).collection('commandes').doc(index).delete();
  }

  adddevis(user, data) {
    return this.store.collection('devis').add({
      user: user,
      data: data
    });
  }

  addSav(data) {
    return this.store.collection('sav').add({
      question: data['question'],
      reponse: data['reponse']
    }).then(info => {
      this.store.collection('sav').doc(info.id).update({
        id: info.id
      });
    });
  }

  deleteSav(uid) {
    return this.store.collection('sav').doc(uid).delete();
  }

  updateUser(user, uid) {
    return this.store.collection('users').doc(uid).update({
      nom: user['lastname'],
      prenom: user['firstname'],
      email: user['email'],
      entreprise: user['company'],
      poste: user['poste'],
      tel: user['tel'],
      siret: user['siret']
    });
  }

  getUser(user: object) {
    return this.store.doc('users/' + user['uid']);
  }

  getAllUser() {
    return this.store.collection('users').valueChanges();
  }

  getAllSav() {
    return this.store.collection('sav').valueChanges();
  }

  getAllEmail() {
    return this.store.collection('newsletter').valueChanges();
  }

  getAllDevis() {
    return this.store.collection('devis').valueChanges();
  }

  postEmail(email) {
    return this.store.collection('newsletter').add({
      email: email
    });
  }

  search(infos) {
    return this.store.collection('users', ref => ref.where(infos['type'], '==', infos['text']));
  }

  searchFAQ(infos) {
    return this.store.collection('sav', ref => ref.where('question', '>=', infos['text']));
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/providers/database.service.ts